import { cn } from "@/common/helpers/utils";
import { useTrackRecentVisit } from "@/common/hooks/use-track-recent-visit";
import { SidebarInset, SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { AppSidebar } from "../app-sidebar/app-sidebar";
import { TopBar } from "../top-bar/top-bar";

interface Props {
  children: ReactNode;
}

function LayoutContent({ children }: Props) {
  const { state, isMobile } = useSidebar();
  const isSidebarVisible = state === "expanded" && !isMobile;
  useTrackRecentVisit();

  return (
    <div
      className={cn(
        "bg-background border-t-border relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden border transition-[margin,border-radius,border-color] duration-200 ease-linear",
        isSidebarVisible
          ? "border-x-border border-b-border mr-2 mb-2 rounded-xl"
          : "rounded-none border-x-transparent border-b-transparent",
      )}
    >
      <div className="flex min-h-0 min-w-0 flex-1 scrollbar-none flex-col gap-1 overflow-auto overscroll-contain p-1 sm:scrollbar-thin sm:scrollbar-gutter-both sm:gap-4 sm:p-4">
        {children}
      </div>
    </div>
  );
}

export function RestrictedLayout({ children }: Props) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3, ease: "easeOut" }}>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="bg-sidebar flex h-screen w-full">
          <TopBar />
          <LayoutContent>{children}</LayoutContent>
        </SidebarInset>
      </SidebarProvider>
    </motion.div>
  );
}
